import StatusPage from "@lib/components/StatusPage";
import { useTranslation } from "react-i18next";

export default function NotFound404({ message }: { message?: string }) {
  const { t } = useTranslation();
  return (
    <StatusPage
      title={t("notFound")}
      code="404"
      description={message ? message : t("sorryWeCouldntFindThisPage")}
    />
  );
}
